export const APP_NAME_INBOX = 'conversations';
export const APP_NAME_NOTIFICATIONS = 'notifications';
